import { SCORECARD_BASE_PERCENTAGE } from './constants'

export const calculateFeedbackPercentage = (
  currentFeedbacksCount: number,
  totalFeedbacksCount: number,
  isPaperCheckInProgress: boolean
): number => {
  // case: feedbacks started populating
  if (isPaperCheckInProgress) return 0

  // case: if paper check is done and it has no errors - 0 Feedbacks
  if (!isPaperCheckInProgress && totalFeedbacksCount === 0) return 100

  // case: feedback is totally populated
  return (
    SCORECARD_BASE_PERCENTAGE +
    ((totalFeedbacksCount - currentFeedbacksCount) / totalFeedbacksCount) *
      (100 - SCORECARD_BASE_PERCENTAGE)
  )
}
